<template>
  <div class="row">
    <loading
      loader="dots"
      :height="170"
      :width="170"
      color="#3282b8"
      background-color="#505273"
      transition="fade"
      :active="isLoading"
      :is-full-page="true"
    ></loading>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg">
          <h2>Total Tonnage Received by Private Contractor Report</h2>
        </div>
        <div class="col-lg-4">
          <span class="demonstration">Select Date Range :</span>
          <el-date-picker
            v-model="selects.date"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="getDatas()"
          ></el-date-picker>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-4">
          <h4>
            Select Site:
            <el-select
              class="select-primary tab"
              placeholder="Single Select"
              v-model="selects.site"
              @change="filterSite()"
            >
              <el-option
                v-for="option in selects.sites"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
        <div class="col-lg-4">
          <h4>
            Select Supplier:
            <el-select
              class="select-primary tab"
              placeholder="Single Select"
              v-model="selects.supplier"
              @change="filterSupplier()"
            >
              <el-option
                v-for="option in selects.suppliers"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
          </h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <card card-body-classes="table-full-width">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <base-input label="rows visible">
                <el-select
                  class="select-info mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <div id="tableku" v-if="this.load == false">
              <el-table :data="reportdetails" style="display: none">
                <el-table-column prop="item"></el-table-column>
                <el-table-column prop="item2"></el-table-column>
              </el-table>
              <el-table style="display: none"></el-table>
              <el-table
                :data="queriedData"
                style="width: 100%"
                height="550"
                :header-cell-style="{
                  background: 'transparent',
                  border: '1px solid #3d3f51',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  border: '1px solid #3d3f51',
                  borderBottom: '0.5px solid #3d3f51',
                }"
                :row-class-name="tableRowClassName"
                :style="(backgroundColor = 'rgb(252, 230, 190)')"
              >
                <el-table-column
                  prop="no"
                  label="NO"
                  align="center"
                  width="50"
                ></el-table-column>
                <el-table-column
                  v-for="column in deviceColumns"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  width="280"
                >
                </el-table-column>
              </el-table>
              <el-table :data="signtitle" style="display: none">
                <el-table-column prop="title1"> </el-table-column>
                <el-table-column prop="title2"> </el-table-column>
                <el-table-column prop="title3"> </el-table-column>
              </el-table>
            </div>
            <div class="d-flex justify-content-center spinner" v-if="load">
              <circle-8></circle-8>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              ></base-pagination>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 text-right">
          <base-button type="primary" @click="exportExcel()"
            >Export to Excel</base-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { Table, TableColumn } from "element-ui";
import { Select, Option, DatePicker } from "element-ui";
import { Modal, BasePagination, BaseSwitch } from "src/components";
import Fuse from "fuse.js";
import { Circle8 } from "vue-loading-spinner";
import swal from "sweetalert2";
import * as XLSX from "sheetjs-style";
import { read, utils, writeFile } from "xlsx";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { debounce } from "src/util/debounce";


export default {
  components: {
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    Loading,
  },
  data() {
    return {
      isLoading: false,

      totalton: 0,

      value2: [],

      deviceColumns: [
        {
          prop: "company",
          label: "Syarikat",
        },
        {
          prop: "platenumber",
          label: "No. Pendaftaran",
        },
        {
          prop: "ticketnumber",
          label: "No. Tiket",
        },
        {
          prop: "jenissampah",
          label: "Jenis Sampah",
        },
        {
          prop: "date",
          label: "Tarikh",
        },
        {
          prop: "tonnage",
          label: "Tan (MT)",
        },
      ],
      timeswitch: false,
      load: false,
      numbering: 1,
      modals: {
        modal0: false,
      },
      // Selecting interval data
      selects: {
        site: "",
        sites: [],
        supplier: "",
        suppliers: [],
        date: "",
      },
      temp: [],
      formattedValue2: 0,
      searchQuery: "",
      // tableData: [],
      tableDatas: [],
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      value1: "",

      tempSite: [],
      tempOwner: [],
      picture: null,
      workbook: null,
      worksheet: null,
      XLSX: null,
      table: null,
      reportdetails: [
        {
          item: "PERKHIDMATAN PENGOPERASIAN DAN PENYELENGGARAN TAPAK PELUPUSAN SANITARI DI BELENGGU, TEMERLOH PAHANG DARUL MAKMUR",
        },
        {
          item: "",
        },
        {
          // item: `${String(datestart)} to ${String(dateend)}`,
          item: "8-9 AUG",
          item2: "LANDFILL: BELENGGU HALT",
        },
        {
          item: "PRIVATE CONTRACTOR (PC)",
        },
      ],
      signtitle: [
        {
          title1: "Prepared By,",
          title2: "Checked By,",
          title3: "Approved By,",
        },
        {
          title1: "_____________",
          title2: "_____________",
          title3: "_____________",
        },
        {
          title1: "Name:",
          title2: "Name:",
          title3: "Name:",
        },
        {
          title1: "Position:",
          title2: "Position:",
          title3: "Position:",
        },
        {
          title1: "Date:",
          title2: "Date:",
          title3: "Date:",
        },
      ],
      cellStyle: "border-bottom: 1px solid white;",
    };
  },
  created() {
    this.getSite();
    this.getSupplier();
  },
  watch: {
    "selects.site"() {
      this.getDatas();
    },
    "selects.supplier"() {
      this.getDatas();
    },
    value2: {
      handler: "getSite",
      deep: true,
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
     searchQuery: debounce(function (search) {
      console.log(search);
      if (search != "") {
        this.tableDatas = this.temp.filter((value) =>
          value.jenissampah.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["jenissampah"],
      threshold: 0.3,
    });
    this.getDatas();


  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
    datas() {
      let datas = {};
      this.tableDatas.forEach((row) => {
        row.datas.forEach((room) => {
          datas[room.platenumber] = 1;
        });
      });
      return Object.keys(datas);
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (row.date == "TOTAL") {
        return "success-row";
      }
    },
    cellFormatter(row, col) {
      let key = JSON.parse(col.property);
      let d = row.datas.find((r) => r.platenumber === key.room);
      if (d && d[key.property]) {
        return d[key.property];
      }
      return "0 ";
    },

    exportExcel() {
      this.XLSX = require("sheetjs-style");
      this.workbook = this.XLSX.utils.book_new();

      let eee = document.getElementById("tableku");

      let ttworksheet = this.XLSX.utils.table_to_book(eee, {
        sheet: "report",
      });
      this.worksheet = ttworksheet.Sheets["report"];

      this.XLSX.utils.book_append_sheet(
        this.workbook,
        this.worksheet,
        "report"
      );

      var wscols = [
        { wch: 40 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
        { wch: 7 },
      ];

      this.worksheet["!cols"] = wscols;

      // style for A2, A3, A4, A5
      let a = ["A2", "A3", "A4", "A5", "A7"];

      for (var i = 0; i < a.length; i++) {
        this.worksheet[a[i]].s = {
          font: {
            name: "Calibri",
            sz: 12,
            // bold: true,
            color: {},
          },
          alignment: {
            horizontal: "left",
            wrapText: "1",
          },
        };
      }

      // style for "B7", "B8", "B9"
      let b = ["B7", "B8", "B9"];
      for (var i = 0; i < b.length; i++) {
        this.worksheet[b[i]].s = {
          font: {
            name: "Calibri",
            sz: 12,
            bold: true,
            color: {},
          },

          alignment: {
            horizontal: "center",
            wrapText: "1",
          },
        };
      }

      this.XLSX.writeFile(
        this.workbook,
        "Total Tonnage Received by Private Contractor Report.csv"
      );
    },

    getSite() {
      this.selects.sites = [];

      this.formattedValue2 = 0;

      this.$http.get(":10001/api/v1/setting/destination").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("hehe", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].DestinationName,
              value: response[i].DestinationCode,
            };

            this.selects.sites.push(obj);
          }

          //default value
          // this.selects.time = this.selects.times[0].value;
          this.selects.date = [moment().startOf("w"), moment().endOf("w")];
          this.selects.site = this.selects.sites[0].value;

          this.getDatas();
        }
      });
    },

    getSupplier() {
      this.selects.suppliers = [];

      this.formattedValue2 = 0;

      this.$http.get(":10001/api/v1/setting/supplier").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log("hehe", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].SupplierName,
              value: response[i].SupplierCode,
            };

            this.selects.suppliers.push(obj);
          }

          //default value
          // this.selects.time = this.selects.times[0].value;
          this.selects.date = [moment().startOf("w"), moment().endOf("w")];
          this.selects.supplier = this.selects.suppliers[0].value;

          this.getDatas();
        }
        // this.tableDatas = [];
      });
    },

    async getDatas() {
      this.tableDatas = [];
      this.isLoading = true;
      this.load = true;

      if (this.selects.site != "" && this.selects.supplier != "") {
        let start = moment(this.selects.date[0]).format("YYYY-MM-DD");
        let end = moment(this.selects.date[1]).format("YYYY-MM-DD");

        console.log(start, end);

        const apiUrl = `:10001/api/v1/report/pc-report?start=${start}&end=${end}&contractor=${this.selects.supplier}&destination=${this.selects.site}`;
        this.$http.get(apiUrl).then((res) => {
          if (!res.error) {
            this.tableDatas = [];
            this.numbering = 1;
            let response = res.message;

            for (let i = 0; i < response.TripList.length; i++) {
              let hoho = parseFloat(res.message.TripList[i].Tonnage);
              const formattedValue = (hoho / 100).toFixed(2);
              var obj = {
                no: this.numbering++,
                company: response.SupplierName,
                platenumber: response.TripList[i].VehicleNumber,
                ticketnumber: response.TripList[i].TicketNumber,
                jenissampah: response.TripList[i].ProductTypeName,
                date: response.TripList[i].Date,
                tonnage: formattedValue,
              };

              this.tableDatas.push(obj);
              this.temp.push(obj);
              this.totalton += res.message.TripList[i].Tonnage;
              this.formattedValue2 = (this.totalton / 100).toFixed(2);
              
            }

            var additionalRow = {
              date: "JUMLAH",

              tonnage: this.formattedValue2,
            };

            this.tableDatas.push(additionalRow);
            this.load = false;

          } else {
          }
        });
        this.isLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  color: black;
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
.photos {
  width: 120px;
  height: 120px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
